import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useSupervisoresOutletContext } from 'pages/Supervisor.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import {
    UpdateSupervisorOutput,
    UpdateSupervisorSchema,
    supervisor,
} from 'service/api'
import { toast } from 'sonner'
import { SupervisorForm } from '../forms/SupervisorForm'

export default function EditarSupervisor() {
    const { id } = useParams()
    const { data } = useSupervisoresOutletContext()
    const s = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = supervisor.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!s) return null

    const handleSubmit: SubmitHandler<UpdateSupervisorOutput> = async data =>
        mutateAsync(data, {
            onSuccess: () => {
                toast.success('Supervisor atualizado com sucesso')
            },
            onError: e => {
                toast.error(`${e.message}`)
            },
        })

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            defaultValues={s}
            schema={UpdateSupervisorSchema}
            open={hasPermission(['update', 'Supervisores'])}
        >
            <Dialog.Title>Editar Supervisor</Dialog.Title>
            <Dialog.Content>
                <SupervisorForm edit />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
